// @flow
import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import subscriptionState from './subscriptions/state'

const storeConf = {
  // modules
  // noteState and searchState are lazy loaded in routes.js

  // global
  state: ({
    article: {
      id: -1,
      isLiked: false,
      likeCount: 0,
    },
    flagModal: {
      active: false,
      id: -1,
    },
    deleteConfirmationModal: {
      active: false,
      id: -1,
      type: '',
    },
    errorModal: {
      active: false,
    },
    loginModal: {
      active: false,
      path: '/',
    },
    user: {
      displayName: 'Guest',
      username: 'guest',
    },
    csrfToken: Laravel && Laravel.csrfToken ? Laravel.csrfToken : '',

    // merge from laravel object as default state
    features: Laravel && Laravel.features ? Laravel.features : {},

    // cdn prefixes, set from ssr _head.blade.php
    cdn: Laravel && Laravel.cdn ? Laravel.cdn : {},

    // ads free video player IDs, set from ssr
    videoPlayer: Laravel && Laravel.videoPlayer ? Laravel.videoPlayer : {},

    // model data, generic to be re-usable
    // type: workout, customWorkout, plan, category, etc
    entity: Laravel && Laravel.entity ? Laravel.entity : {},

    // this could be separate vuex modules in the future
    ...subscriptionState,

    // TODO: this could be a separate store, merged with routines, but just single bool
    // used with plans-scheduled-instances.vue and header-toolbar-buttons.vue
    refreshScheduledInstances: false,
  }: State),

  actions: actions,

  getters: getters,

  mutations: mutations,
}

Vue.use(Vuex)
// router is used in comments (possibly other places), not SPA
Vue.use(VueRouter)

export default new Vuex.Store(storeConf)
export const router = new VueRouter({
  mode: 'history',
})
